<template>
  <div class="p-20 mt-40 rounded-4" :class="isDarkMode ? 'bg-sidebar' : 'bg-grey-450'">
    <div class="flex items-start font-bold">
      <p class="text-15">{{ title }}</p>
      <p v-if="isFreePlan" class="bg-green-main text-12 text-white rounded-2 ml-5 px-5">Free</p>
    </div>

    <p v-if="isFreePlan" class="text-13 text-app-color text-opacity-80 mt-5 mb-10">
      You used {{ persentag }}% of the space available in the free plan ({{ currentPlan.maxSize / 1024 / 1024 }}MB)
    </p>
    <p v-if="isTrialPlan" class="text-13 text-app-color text-opacity-80 mt-5 mb-10">
      You have {{ trialDaysLeft }} {{ trialDaysLeft === 1 ? 'day' : 'days' }} left on your free trial.
      <button class="underline" @click="openPlansTab">Upgrade today</button>
      and run your business with hello ivy teams.
    </p>

    <div class="w-full h-15 bg-grey-800 rounded-4 overflow-hidden mb-10">
      <div
        class="h-full"
        :class="isHueTheme ? 'bg-link-color' : 'bg-main-color'"
        :style="`width: ${ persentag }%`"
      />
    </div>

    <div v-if="isFreePlan" class="text-13 text-app-color text-opacity-80">
      <p class="font-bold">And you've created:</p>
      <ul>
        <li>{{ stats.books }} of {{ currentPlan.maxBooks }} spaces</li>
        <li>{{ stats.projects }} of {{ currentPlan.maxProjects }} pages</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ProgressBarModule',

  computed: {
    ...mapState({
      stats: state => state.plan.stats,
      team: state => state.team.team,
      user: state => state.profile.user
    }),
    ...mapGetters(['currentPlan', 'isDarkMode', 'isHueTheme', 'isTrialPlan', 'isFreePlan', 'trialDaysLeft']),

    persentag () {
      return this.isFreePlan
        ? (this.stats.size / this.currentPlan.maxSize * 100).toFixed(2)
        : ((15 - this.trialDaysLeft) / 15 * 100).toFixed(2)
    },

    title () {
      return this.isTrialPlan ? 'Your trial period' : 'Your usage'
    },

    subTitle () {
      return this.isTrialPlan
        ? ''
        : `You used ${this.persentag}% of the space available in the free plan (${this.currentPlan.maxSize / 1024 / 1024}MB)`
    }
  },

  methods: {
    ...mapMutations(['changeActiveState', 'toggleSettingsModal', 'toggleAside']),

    openPlansTab () {
      window.open(`https://helloivy.co/upgrade?userId=${this.user.id}&teamId=${this.team.id}`, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
ul li {
  padding-left: 15px;

  &:before {
    font-size: 40px;
    top: 5px;
  }
}
</style>
